import { useState } from 'react';
import { FailureSeverity, isValidationErrorResponse } from 'buzz_lib_shared';
export const useRequestFailureHandler = () => {
  const [errors, setErrors] = useState([]);
  const handleRequestError = res => {
    if (isValidationErrorResponse(res)) {
      setErrors(res.Errors);
      return;
    }
    setErrors([{
      message: 'Unexpected error happened.',
      severity: FailureSeverity.Error,
      code: 'UNEXPECTED_ERROR'
    }]);
  };
  const resetErrors = () => setErrors([]);
  return {
    errors,
    handleRequestError,
    resetErrors
  };
};